import Vue from 'src/views/base'
import { Component } from 'vue-property-decorator'
import template from './success.vue'
import PageTips from '../mixins'

@Component({
    name: 'success',
    mixins: [ template ],
    components: {
        PageTips
    }
})
export default class Success extends Vue {
    created() {
     
    }
}



// WEBPACK FOOTER //
// ./src/views/page/main/success/index.js